import { forwardRef as y, useCallback as j } from "react";
import { useThemeUI as D, Link as O } from "theme-ui";
import { ChevronRight16Icon as T, ChevronRight24Icon as U } from "@material-bank/mb-icons";
import { smoothScrollToElementId as z } from "@material-bank/ds-utils";
import { link as A, loadingLink as B, activeLink as E, underlinedLink as N, inheritedLink as P } from "./styles.js";
import "@theme-ui/css";
import "../../lib/css/match-media-context.js";
import { Responsive as t } from "../../lib/css/Responsive.js";
import { Skeleton as W } from "../Skeleton/Skeleton.js";
import { jsx as o, jsxs as d } from "theme-ui/jsx-runtime";
const $ = y((s, h) => {
  var c;
  const {
    variant: l = "primary",
    arrowSize: m = "md",
    icon: p,
    loading: r = !1,
    children: k,
    withArrow: f,
    withUnderline: L,
    active: u,
    inherit: v,
    onClick: n,
    href: i,
    startIcon: w,
    endIcon: x = p,
    smoothScroll: a = !0,
    activeSx: I,
    ...C
  } = s, {
    theme: S
  } = D(), b = j((e) => {
    if (r && e.preventDefault(), a && (i != null && i.startsWith("#"))) {
      e.preventDefault();
      const R = i.split("#")[1];
      z(R);
    }
    n == null || n(e);
  }, [r, a, i, n]), g = m === "md" ? "desktop" : "mobile";
  return /* @__PURE__ */ o(W, {
    enabled: r,
    asChild: !0,
    children: /* @__PURE__ */ d(O, {
      ...C,
      variant: l,
      onClick: b,
      ref: h,
      href: i,
      sx: {
        ...A,
        ...r && B,
        ...(c = S.links) == null ? void 0 : c[l],
        ...u && {
          ...E,
          ...I
        },
        ...L && N,
        ...v && P,
        ...s.sx
      },
      children: [w, k, x, f && /* @__PURE__ */ d(t, {
        lockBreakpoint: m === "responsive" ? void 0 : g,
        children: [/* @__PURE__ */ o(t, {
          showOn: "mobiles",
          children: /* @__PURE__ */ o(T, {})
        }), /* @__PURE__ */ o(t, {
          showOn: "desktop",
          children: /* @__PURE__ */ o(U, {})
        })]
      })]
    })
  });
});
$.displayName = "Link";
export {
  $ as Link
};
